export default __webpack_public_path__ + "static/media/dwarakaAboutOne.05cf28d7.jpg";